import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ArrowLeft, Compass, LifeBuoy, LayoutDashboard } from "lucide-react";

import { smallLogo } from "../assets/images";
import { SUPPORT_URL } from "../components/layout/nav-items";
import { Button } from "../components/ui/button";
import { useAuth } from "../context/auth-context";

const NotFound = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { isAuthenticated } = useAuth();

  const homeHref = isAuthenticated ? "/dashboard" : "/login";

  return (
    <div className="relative flex min-h-screen w-full flex-col items-center justify-center overflow-hidden bg-muted px-5 py-16 font-manrope">
      {/* Soft brand glow behind the content */}
      <div
        aria-hidden
        className="pointer-events-none absolute -top-40 left-1/2 size-[520px] -translate-x-1/2 rounded-full bg-primary/10 blur-3xl"
      />

      <div className="relative w-full max-w-[520px] text-center">
        <img
          src={smallLogo}
          alt="Deexoptions"
          className="mx-auto mb-10 h-[25px] w-[90px]"
        />

        <p
          aria-hidden
          className="select-none bg-gradient-to-b from-primary to-primary/30 bg-clip-text font-sora text-[104px] font-bold leading-none text-transparent mds:text-[132px]"
        >
          404
        </p>

        <h1 className="mt-2 font-sora text-[22px] font-bold text-foreground">
          We couldn't find that page
        </h1>
        <p className="mx-auto mt-3 max-w-[420px] text-[14px] font-medium leading-relaxed text-muted-foreground">
          The page you're looking for doesn't exist, or it may have moved.
          Check the address and try again.
        </p>

        <p className="mx-auto mt-4 w-fit max-w-full truncate rounded-full border bg-background px-3 py-1.5 font-mono text-[12px] text-muted-foreground">
          {pathname}
        </p>

        <div className="mt-8 flex flex-col items-center justify-center gap-3 mds:flex-row">
          <Button
            variant="outline"
            onClick={() => navigate(-1)}
            className="h-11 w-full gap-2 rounded-xl bg-background mds:w-auto"
          >
            <ArrowLeft className="size-4" />
            Go back
          </Button>

          <Button asChild className="h-11 w-full gap-2 rounded-xl mds:w-auto">
            <Link to={homeHref}>
              {isAuthenticated ? (
                <LayoutDashboard className="size-4" />
              ) : (
                <Compass className="size-4" />
              )}
              {isAuthenticated ? "Back to dashboard" : "Go to sign in"}
            </Link>
          </Button>
        </div>

        <div className="mt-10 border-t pt-6">
          <p className="text-[13px] font-medium text-muted-foreground">
            Still stuck?{" "}
            <a
              href={SUPPORT_URL}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-1 font-semibold text-primary hover:underline"
            >
              <LifeBuoy className="size-3.5" />
              Talk to support
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
